import Image from "next/image";
import React from "react";
import styles from "./upsc-psir-optional.module.css";
import Carousel from 'react-bootstrap/Carousel';
import crashcourse from "../../assets/images/home/Moksha/PSIR/PSIR-Web-Banner.jpg";
import Mobcrashcourse from "../../assets/images/home/Moksha/PSIR/PSIR-Mobile-Banner.jpg";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Link from "next/link";
import Head from "next/head";

const UPSC_Main_Test_Series_2023 = () => {
    const BGimg = [
        // { img: carouselBGimg4, alt: "carousel", link: "/" },
        // { img: carouselBGimg3, alt: "carousel", link: "/upsc-mains-test-series" }
    ]
    return (
        <>

        <Head>
            <meta charset="UTF-8" />
            
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>UPSC PSIR Mains Test Series 2026</title>
            <meta name="title" content="UPSC PSIR Mains Test Series 2026" />
            <meta name="description" content="Enroll in UPSC PSIR Mains Test Series 2026 at Shankar IAS Academy. Practice high-quality tests, improve answer writing & ace the Mains exam." />
            <link rel="canonical" href=" https://www.shankariasacademy.com/upsc-psir-mains-test-series/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="UPSC PSIR Mains Test Series 2026" />
            <meta property="og:description" content="Enroll in UPSC PSIR Mains Test Series 2026 at Shankar IAS Academy. Practice high-quality tests, improve answer writing & ace the Mains exam." />
            <meta property="og:url" content=" https://www.shankariasacademy.com/upsc-psir-mains-test-series/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>


        <Navbar title="upsc" />

        <div className="container">

            <div className="row">
            <div className="col pt-3 pt-md-4">
                <h1 className={`${styles.pagemaintitle}`}>UPSC PSIR Mains Test Series 2026 </h1>
            </div>
            </div>

            <div className="row d-none d-md-block">
            <div className="col mb-3">
              <Image
                src={crashcourse}
                alt="UPSC Mains Crash Course 2024"
                title="UPSC Mains Crash Course 2024"
                className="img-fluid w-100"
              />
            </div>
          </div>

            <div className="row d-block d-md-none">
          <div className="col mb-3">
              <Image
                src={Mobcrashcourse}
                alt="UPSC Mains Crash Course 2024"
                title="UPSC Mains Crash Course 2024"
                className="img-fluid w-100"
              />
            </div>
          </div> 
        </div>

        

        <div className="container py-4">
           <div className={styles.customTable}>
                <div className={`${styles.tableRow} ${styles.tableHead}`}>
                    <div className={styles.tableCol}>Batch</div>
                    <div className={styles.tableCol}>Starts On</div>
                    <div className={styles.tableCol}>Mode</div>
                    <div className={styles.tableCol}>Fee</div>
                    <div className={styles.tableCol}>Schedule</div>
                    <div className={styles.tableCol}>Payment</div>
                </div>

                <div className={`${styles.tableRow} ${styles.tableBody}`}>
                    <div className={styles.tableCol}>
                        <span className={styles.mobileLabel}>Batch</span>
                        <p className={`${styles.batchName} mb-0`}>
                            PSIR BATCH - I
                        </p>
                    </div>

                    <div className={styles.tableCol}>
                        <span className={styles.mobileLabel}>Starts On</span>
                        <p className={`${styles.normalText} mb-0`}>
                           20.06.2026
                        </p>
                    </div>

                    <div className={styles.tableCol}>
                        <span className={styles.mobileLabel}>Mode</span>
                        <p className={`${styles.normalText} mb-0`}>
                           Online / Offline
                        </p>
                    </div>

                    <div className={styles.tableCol}>
                        <span className={styles.mobileLabel}>Fee</span>
                        <p className={`${styles.normalText} mb-0`}>
                           ₹ 6,000
                        </p>
                    </div>

                    <div className={styles.tableCol}>
                        <span className={styles.mobileLabel}>Schedule</span>
                        <a
                        //     href="#"
                            href="https://shankariasacademy.com/pdf/UPSC-2026/Moksha-Optional/PSIR/PSIR-2026-B1.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.pdfBtn}
                        >
                        <i className="bi bi-file-earmark-pdf-fill me-2"></i>
                           Click Here
                        </a>
                    </div>

                    <div className={styles.tableCol}>
                        <span className={styles.mobileLabel}>Payment</span>
                        <span className="d-inline-block"><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Pay Now</a></span>
                    </div>
                </div>

                <div className={`${styles.tableRow} ${styles.tableBody} `}>
                    <div className={styles.tableCol}>
                        <span className={styles.mobileLabel}>Batch</span>
                        <p className={`${styles.batchName} mb-0`}>
                            PSIR BATCH - II
                        </p>
                    </div>

                    <div className={styles.tableCol}>
                        <span className={styles.mobileLabel}>Starts On</span>
                        <p className={`${styles.normalText} mb-0`}>
                           26.08.2026
                        </p>
                    </div>

                    <div className={styles.tableCol}>
                        <span className={styles.mobileLabel}>Mode</span>
                        <p className={`${styles.normalText} mb-0`}>
                           Online / Offline
                        </p>
                    </div>

                    <div className={styles.tableCol}>
                        <span className={styles.mobileLabel}>Fee</span>
                        <p className={`${styles.normalText} mb-0`}>
                            New student: ₹ 16,000 
                        </p>
                        <p className={`${styles.normalText} mb-0`}>
                            Old Student:  ₹ 12,000
                        </p>
                        <p className={`${styles.normalText} mb-0`}>
                             2025 Students : ₹ 8000
                        </p>
                    </div>

                    <div className={styles.tableCol}>
                        <span className={styles.mobileLabel}>Schedule</span>
                        <a
                        //     href="#"
                            href="https://shankariasacademy.com/pdf/UPSC-2026/Moksha-Optional/PSIR/PSIR-2026-B2.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.pdfBtn}
                        >
                        <i className="bi bi-file-earmark-pdf-fill me-2"></i>
                           Click Here
                        </a>
                    </div>

                    <div className={styles.tableCol}>
                        <span className={styles.mobileLabel}>Payment</span>
                        <span className="d-inline-block"><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Pay Now</a></span>
                    </div>
                </div>
                <div className={`${styles.tableRow} ${styles.tableBody} `}>
                    <div className={styles.tableCol}>
                        <span className={styles.mobileLabel}>Batch</span>
                        <p className={`${styles.batchName} mb-0`}>
                            PSIR BOOT CAMP-CHENNAI (2026)
                        </p>
                    </div>

                    <div className={styles.tableCol}>
                        <span className={styles.mobileLabel}>Starts On</span>
                        <p className={`${styles.normalText} mb-0`}>
                           20.06.2026
                        </p>
                    </div>

                    <div className={styles.tableCol}>
                        <span className={styles.mobileLabel}>Mode</span>
                        <p className={`${styles.normalText} mb-0`}>
                           Online / Offline
                        </p>
                    </div>

                    <div className={styles.tableCol}>
                        <span className={styles.mobileLabel}>Fee</span>
                        <p className={`${styles.normalText} mb-0`}>
                            ₹ 2,000 
                        </p>
                        
                    </div>

                    <div className={styles.tableCol}>
                        <span className={styles.mobileLabel}>Schedule</span>
                        <a
                        //     href="#"
                            href="https://shankariasacademy.com/pdf/UPSC-2026/Moksha-Optional/PSIR/PSIR-BOOT-CAMP-CHENNAI.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.pdfBtn}
                        >
                        <i className="bi bi-file-earmark-pdf-fill me-2"></i>
                           Click Here
                        </a>
                    </div>

                    <div className={styles.tableCol}>
                        <span className={styles.mobileLabel}>Payment</span>
                        <span className="d-inline-block"><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Pay Now</a></span>
                    </div>
                </div>
                 <div className={`${styles.tableRow} ${styles.tableBody} `}>
                    <div className={styles.tableCol}>
                        <span className={styles.mobileLabel}>Batch</span>
                        <p className={`${styles.batchName} mb-0`}>
                            PSIR BOOT CAMP-DELHI (2026)
                        </p>
                    </div>

                    <div className={styles.tableCol}>
                        <span className={styles.mobileLabel}>Starts On</span>
                        <p className={`${styles.normalText} mb-0`}>
                           20.06.2026
                        </p>
                    </div>

                    <div className={styles.tableCol}>
                        <span className={styles.mobileLabel}>Mode</span>
                        <p className={`${styles.normalText} mb-0`}>
                           Online / Offline
                        </p>
                    </div>

                    <div className={styles.tableCol}>
                        <span className={styles.mobileLabel}>Fee</span>
                        <p className={`${styles.normalText} mb-0`}>
                         ₹ 2,000 
                        </p>
                        
                    </div>

                    <div className={styles.tableCol}>
                        <span className={styles.mobileLabel}>Schedule</span>
                        <a
                        //     href="#"
                            href="https://shankariasacademy.com/pdf/UPSC-2026/Moksha-Optional/PSIR/PSIR-BOOT-CAMP-Delhi.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.pdfBtn}
                        >
                        <i className="bi bi-file-earmark-pdf-fill me-2"></i>
                           Click Here
                        </a>
                    </div>

                    <div className={styles.tableCol}>
                        <span className={styles.mobileLabel}>Payment</span>
                        <span className="d-inline-block"><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Pay Now</a></span>
                    </div>
                </div>
           </div>
        </div>

        {/* Mainst 2025*/}

        {/* <div className="container d-none d-md-block">  
            <h2 className={`${styles.sectiontitle1} mb-0 py-3`}>UPSC PSIR Mains Test Series 2025</h2>
        </div> */}
        
         {/* <div className="container d-none d-md-block pt-4" style={{backgroundColor:""}}>
                
                <div className={`${styles.classesborder} row`} style={{backgroundColor:"#fffbf2"}}>
                    <div className="col-md-3 border pt-3 pb-3 d-none d-md-block">
                            <p className={`${styles.mainshead} mb-0`}>CHOOSE YOUR BEST FIT </p>
                    </div>
                    <div className="col-md-3 border pt-3 pb-3 d-none d-md-block">
                            <p className={`${styles.mainshead} mb-0`}>FRESHERS</p>
                    </div>
                    <div className="col-md-3 border pt-3 pb-3 d-none d-md-block">
                            <p className={`${styles.mainshead} mb-0`}>MASTERS</p>
                    </div>
                    <div className="col-md-3 border pt-3 pb-3 d-none d-md-block">
                            <p className={`${styles.mainshead} mb-0`}>TARGET - 2026</p>
                    </div>
                </div>
                <div className={`${styles.classesborder} row`}>
                    <div className="col-md-12 d-block d-md-none">
                            <p className={`${styles.mainshead} mb-0`}>Choose your Best Fit</p>
                    </div>
                    <div className="col-12 col-md-3 border pt-3 pb-3">
                    <p className={`${styles.subhead} mb-0 mb-md-2`}>Whom ?</p>
                    </div>
                    <div className="col-12 d-block d-md-none">
                            <p className={`${styles.bgboxbg} p-2`}>FRESHERS</p>
                    </div>   
                    <div className="col-12 col-md-3 border pt-3 pb-3">
                    <p className={`${styles} mb-0 mb-md-2`}>Suits freshers appearing for Mains 2025

                    </p>
                    </div>
                    <div className="col-12 d-block d-md-none">
                            <p className={`${styles.bgboxbg} p-2`}>VETERANS</p>
                    </div>
                    <div className="col-12 col-md-3 border pt-3 pb-3">
                            <p className={`${styles} mb-0`}>Suits aspirants with Prior mains experience and appearing for Mains 2025

        </p>
                    </div>
                    <div className="col-12 d-block d-md-none">
                            <p className={`${styles.bgboxbg} p-2`}>LONG TERM</p>
                    </div>
                    <div className="col-12 col-md-3 border pt-3 pb-3">
                            <p className={`${styles} mb-0`}>Suits aspirants who want exhaustive optional answer writing practice for Mains 2026
        </p>
                    </div>
                </div>
                <div className={`${styles.classesborder} row`}>
                    <div className="col-md-12 d-block d-md-none">
                            <p className={`${styles.mainshead} mb-0`}>Choose your Best Fit</p>
                    </div>
                    <div className="col-12 col-md-3 border pt-3 pb-3">
                    <p className={`${styles.subhead} mb-0 mb-md-2`}>Tests</p>
                    </div>
                    <div className="col-12 d-block d-md-none">
                            <p className={`${styles.bgboxbg} p-2`}>FRESHERS</p>
                    </div>   
                    <div className="col-12 col-md-3 border pt-3 pb-3">
                    <p className={`${styles} mb-0 mb-md-2`}>6 Sectional Test (150 Marks) </p>
                    <p className={`${styles} mb-0`}>2 x 2 Full Test </p>
                    </div>
                    <div className="col-12 d-block d-md-none">
                            <p className={`${styles.bgboxbg} p-2`}>VETERANS</p>
                    </div>
                    <div className="col-12 col-md-3 border pt-3 pb-3">
                            <p className={`${styles} mb-0`}>4 Sectional Test (250 Marks)  </p>
                            <p className={`${styles} mb-0`}>2 x 2 Full Test </p>
                    </div>
                    <div className="col-12 d-block d-md-none">
                            <p className={`${styles.bgboxbg} p-2`}>LONG TERM</p>
                    </div>

                    <div className="col-12 col-md-3 border pt-3 pb-3">
                            <p className={`${styles} mb-0`}>15 Unit Tests (100 Marks)</p>
                            <p className={`${styles} mb-0`}>4 Revison Tests (150 Marks)</p>
                            <p className={`${styles} mb-0`}>2 x 2 Full Test</p>
                    </div>
                </div>
                <div className={`${styles.classesborder} row`}>
                <div className="col-md-12 d-block d-md-none">
                            <p className={`${styles.mainshead} mb-0`}>Choose your Best Fit</p>
                    </div>
                    <div className="col-12 col-md-3 border pt-3 pb-3">
                            <p className={`${styles.mainshead} mb-0`}>Schedule</p>
                    </div>
                    
                    <div className="col-12 d-block d-md-none">
                            <p className={`${styles.bgboxbg} p-2`}>FRESHERS</p>
                    </div>   
                    <div className="col-12 col-md-3 border pt-3 pb-3 text-center">
                    <span className="d-inline-block pt-2"><a href="https://www.shankariasacademy.com/pdf/Moksha-Mains-2026/psir/PSIR-2025-TB-1-Freshers.pdf" target="_blank" className={`${styles.paybill}`}><i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"20px",color:"#DB1B0D"}}></i>Click here</a></span>                                       
                    </div>
                    <div className="col-12 d-block d-md-none">
                            <p className={`${styles.bgboxbg} p-2`}>VETERANS</p>
                    </div>
                    <div className="col-12 col-md-3 border pt-3 pb-3 text-center">
                    <span className="d-inline-block pt-2 text-center"><a href="https://www.shankariasacademy.com/pdf/Moksha-Mains-2026/psir/PSIR-2025-TB-1-Masters.pdf" target="_blank" className={`${styles.paybill}`}><i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"20px",color:"#DB1B0D"}}></i>Click here</a></span>                                       
                    </div>
                    <div className="col-12 d-block d-md-none">
                            <p className={`${styles.bgboxbg} p-2`}>LONG TERM</p>
                    </div>
                    <div className="col-12 col-md-3 border pt-3 pb-3 text-center">
                    <span className="d-inline-block pt-2 text-center"><a href="https://www.shankariasacademy.com/pdf/Moksha-Mains-2026/psir/PSIR-2025-TB-2-Target.pdf" target="_blank" className={`${styles.paybill}`}><i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"20px",color:"#DB1B0D"}}></i>Click here</a></span>                                       
                    </div>
                </div>
                <div className={`${styles.classesborder} row`}>
                    <div className="col-md-12 d-block d-md-none">
                            <p className={`${styles.mainshead} mb-0`}>Choose your Best Fit</p>
                    </div>
                    <div className="col-12 col-md-3 border pt-3 pb-3">
                            <p className={`${styles.mainshead} mb-0`}>Admission</p>
                    </div>
                    <div className="col-12 d-block d-md-none">
                            <p className={`${styles.bgboxbg} p-2`}>FRESHERS</p>
                    </div>   
                    <div className="col-12 col-md-3 border pt-3 pb-3 text-center">
                    <span className="d-inline-block"><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Click here</a></span>
                    </div>
                    <div className="col-12 d-block d-md-none">
                            <p className={`${styles.bgboxbg} p-2`}>VETERANS</p>
                    </div>
                    <div className="col-12 col-md-3 border pt-3 pb-3 text-center">
                    <span className="d-inline-block text-center"><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Click here</a></span>
                    </div>
                    <div className="col-12 d-block d-md-none">
                            <p className={`${styles.bgboxbg} p-2`}>LONG TERM</p>
                    </div>
                    <div className="col-12 col-md-3 border pt-3 pb-3 text-center">
                    <span className="d-inline-block text-center"><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Click here</a></span>
                    </div>
                </div>

        </div>  */}

        {/* <div className="container-fluid py-3 py-md-4 pt-xl-5 d-block d-md-none" id="gsttestseries">
            <div style={{background: '#fffbf2 0% 0% no-repeat padding-box', opacity: '1'}}> 
                        <h2 className={`${styles.sectiontitle1} mb-0 py-3`}>UPSC PSIR Mains Test Series 2025</h2>
                            <div className="container">
                                    <div className="row">  
                                    
                                        <div className="col-12 col-md-8 border pt-3 pb-3">
                                                <div className="row col-12 p-2">
                                                    <p className={`${styles.mobhead}`}>Choose Your Best Fit</p>
                                                        <div className={`${styles.bgboxbg} col-12 col-md-2 `}>
                                                                <span className="d-inline-block p-2">FRESHERS</span>
                                                        </div> 
                                                        <div className="col-12 col-md-10 pt-2">
                                                                <span className="d-inline-block">Suits freshers appearing for Mains 2025
                                                                    <hr/>6 Sectional Test (150 Marks) <br/>2 x 2 Full Test</span>
                                                        </div> 

                                                        <div className="col-12 pt-2 pb-2 text-center">
                                                            <span className="d-inline-block  "><a href="https://www.shankariasacademy.com/pdf/Moksha-Mains-2026/psir/PSIR-2025-TB-1-Freshers.pdf" target="_blank" className={`${styles.paybill}`}><i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"20px",color:"#DB1B0D"}}></i>Click here</a></span>
                                                    </div>
                                                <hr/>
                                                        <div className="md-border col-12 pt-2 text-center">
                                                                <span className="d-inline-block "><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Click here</a></span>
                                                        </div> 
                                                </div>

                                                <div className="row col-12  p-2 pt-3">
                                                    <div className={`${styles.bgboxbg} col-12 col-md-2`}>
                                                            <span className="d-inline-block p-2">MASTERS</span>
                                                    </div> 
                                                    <div className="col-12 col-md-10 pt-2 ">
                                                            <span className="d-inline-block">Suits aspirants with Prior mains experience and appearing for Mains 2025

                                                            <hr/>4 Sectional Test (250 Marks)<br/>2 x 2 Full Test</span>
                                                    </div> 

                                                    <div className="col-12 pt-2 pb-2 text-center">
                                                            <span className="d-inline-block  "><a href="https://www.shankariasacademy.com/pdf/Moksha-Mains-2026/psir/PSIR-2025-TB-1-Masters.pdf" target="_blank" className={`${styles.paybill}`}><i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"20px",color:"#DB1B0D"}}></i>Click here</a></span>
                                                    </div>
                                                <hr/>
                                                        <div className="md-border col-12 pt-2 text-center">
                                                                <span className="d-inline-block "><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Click here</a></span>
                                                        </div> 
                                                </div>

                                                <div className="row col-12  p-2 pt-3">
                                                    <div className={`${styles.bgboxbg} col-12 col-md-2`}>
                                                            <span className="d-inline-block p-2">TARGET - 2026</span>
                                                    </div> 
                                                    <div className="col-12 col-md-10 pt-2">
                                                            <span className="d-inline-block">Suits aspirants who want exhaustive optional answer writing practice for Mains 2026

                                                            <hr/>15 Unit Tests (100 Marks) <br/>4 Revison Tests (150 Marks) <br/>2 x 2 Full Test</span>
                                                    </div> 

                                                    <div className="col-12 pt-2 pb-2 text-center">
                                                            <span className="d-inline-block  "><a href="https://www.shankariasacademy.com/pdf/Moksha-Mains-2026/psir/PSIR-2025-TB-2-Target.pdf" target="_blank" className={`${styles.paybill}`}><i className="bi bi-file-earmark-pdf-fill" style={{fontSize:"20px",color:"#DB1B0D"}}></i> Click here</a></span>
                                                    </div>
                                                <hr/>
                                                        <div className="md-border col-12 pt-2 text-center">
                                                                <span className="d-inline-block "><a href="https://admissionsv1.shankariasacademy.com/" target="_blank" className={`${styles.normalbutton} d-inline-block text-center align-middle`}>Click here</a></span>
                                                        </div> 
                                                </div>
                                        </div>
                                    </div>
                                </div>
                </div>
                    
        </div>  */}
          
            <Footer />
        </>
    )
}
export default UPSC_Main_Test_Series_2023;
